import ConfigCatProvider from "./providers/ConfigCatProvider";
import DefaultFeatureFlagProvider from "./providers/DefaultFeatureFlagProvider";
import StatsigProvider from "./providers/StatsigProvider";

const PROVIDERS = {
  CONFIGCAT: "configcat",
  STATSIG: "statsig",
};

export default class FeatureFlagProviderFactory {
  static createProvider(providerName, sdkKey, environment) {
    switch (providerName) {
      case PROVIDERS.CONFIGCAT:
        return new ConfigCatProvider(sdkKey, environment);
      case PROVIDERS.STATSIG:
        return new StatsigProvider(sdkKey, environment);
      default:
        return new DefaultFeatureFlagProvider();
    }
  }
}
